<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p class="message">{{ data.message }}</p>
</div>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{ data.cancelText || 'Annuleren' }}</button>
  <button mat-flat-button [mat-dialog-close]="true" cdkFocusInitial>
    {{ data.confirmText || 'Bevestigen' }}
  </button>
</mat-dialog-actions>
